export default __webpack_public_path__ + "static/media/Noblogedit.f27576cb.png";